/**
 * Expire an auth cookie that was scoped to a single host.
 *
 * Until this change, Django set the session cookie with the estimator host as
 * its domain (AUTH_COOKIE_DOMAIN defaulted to BASE_URL and was unset in the
 * staging and production env files). It is now set on the parent domain so a
 * session spans both hosts -- but every already-signed-in user still holds the
 * narrow one. Two cookies of the same name then go out on every request in an
 * order the spec does not define, and the stale one can win.
 *
 * Deleting a cookie means writing it back expired with the same name, path and
 * domain, which is what this does. It is a no-op once nobody holds the old
 * cookie any more, and can be deleted a release or two after this ships.
 */
export function dropLegacyHostCookie(
  document: { cookie: string },
  name: string,
  hosts: readonly string[],
): void {
  if (!new RegExp(`(?:^|;\\s*)${name}=`).test(document.cookie)) {
    return;
  }
  for (const host of hosts) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${host}; path=/`;
  }
}
